function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M7.177 14.257l.089.26a1.719 1.719 0 002.185 1.065v0a1.719 1.719 0 001.065-2.185l-.089-.259M8.239 3.903l-.225-.651A1.375 1.375 0 006.266 2.4v0a1.376 1.376 0 00-.853 1.747l.225.651"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M4.165 8.824v0a3.399 3.399 0 012.107-4.32l1.286-.442a3.399 3.399 0 014.32 2.107v0l.682 1.983a1.5 1.5 0 00.76.86l.612.297c.358.175.631.484.76.86v0a1.418 1.418 0 01-.879 1.802l-7.6 2.617a1.418 1.418 0 01-1.803-.879v0a1.5 1.5 0 01.07-1.146l.297-.611c.175-.358.2-.77.07-1.146l-.682-1.982z",
  clipRule: "evenodd"
}));